import React from 'react';
import ContactTeaser from '@boschebike/ebds-react/dist-esm/components/ContactTeaser.js';
import { IconAsChunk } from '../../ebds/iconProvider.js';

/**
 * @typedef {import('../../App.d.ts').ContactTeaserProps} ContactTeaserProps
 * @typedef {import('../../../app.d.ts').ContactTeaserCardProps} ContactTeaserCardProps
 */
/**
 *
 * @param {ContactTeaserProps} props
 * @returns {Element}
 */
export default (props) => {
  /**
   * @type {Array<ContactTeaserCardProps>}
   */
  const contactTeaserCards = props.contactCard.map((card) => ({
    subheadline: card.fields.subheadline,
    icon: <IconAsChunk iconName={card.fields.icon} />,
    iconSrText: card.fields.icon,
    description: card.fields.description,
    contactType: card.fields.contactType.map((type) => ({
      icon: <IconAsChunk iconName={type.fields.icon} />,
      protocol: type.fields.icon === 'Mail' ? 'mail' : 'tel',
      contactData: type.fields.contactData,
    })),
  }));

  return (
    <ContactTeaser
      data-testid="contact-teaser"
      headline={props.headline}
      img={(
        <img
          src={props.image.fields.file.url}
          alt=""
          width={props.image.fields.file.details.image.width}
          height={props.image.fields.file.details.image.height}
        />
      )}
      contactCard={contactTeaserCards}
    />
  );
};
